import useId from '../utils/useId';
import * as React from 'react';
export const wixSvg = React.forwardRef(function wixSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1A1F36',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_wix__a_${id_0})`,
        fill: '#fff',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M27.9 11h-1.32c-.367 0-.71.181-.915.485L23.9 14.089a.119.119 0 0 1-.197 0l-1.765-2.604a1.104 1.104 0 0 0-.914-.485h-1.32l3.145 4.64-3.128 4.613h1.32c.366 0 .709-.181.914-.485l1.748-2.578a.119.119 0 0 1 .197 0l1.748 2.578c.205.304.548.485.914.485h1.32l-3.128-4.614L27.9 11Zm-10.913.947v8.306h.631a.946.946 0 0 0 .947-.947V11h-.631a.946.946 0 0 0-.947.947ZM15.83 11h-.561c-.618 0-1.154.428-1.29 1.03l-1.257 5.522-1.1-5.154a1.754 1.754 0 0 0-2.18-1.32c-.638.177-1.11.715-1.248 1.361l-1.088 5.106-1.254-5.514A1.325 1.325 0 0 0 4.562 11H4l2.104 9.253h.798c.723 0 1.348-.506 1.5-1.214l1.344-6.313a.171.171 0 0 1 .167-.135c.08 0 .15.057.167.135l1.346 6.313a1.534 1.534 0 0 0 1.5 1.214h.8L15.83 11Z',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_wix__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(4 11)',
          d: 'M0 0h24v9.253H0z',
        }),
      ),
    ),
  );
});
wixSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var wix = {
  category: 'brand',
  colorable: false,
  name: 'wix',
  svg: wixSvg,
};
